import { Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const PaginationComponent = ({ listLength, path, page, filter, limit }) => {
    const navigate = useNavigate();
    const totalPages = Math.max(Math.ceil(Number(listLength) / limit), 1);
    const currentPage = Number(page) || 1;

    const goToPage = (pageNum) => {
        navigate(`${path}/page/${pageNum}${filter ? `/${filter}` : ""}`);
        document.querySelector('.wrapper')?.scrollTo(0, 0);
    };

    const pageNumbers = [];

    pageNumbers.push(1);

    if (currentPage > 4) {
        pageNumbers.push("left-ellipsis");
    }

    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    if (currentPage <= 4) {
        start = 2;
        end = 5;
    }
    if (currentPage >= totalPages - 3) {
        start = totalPages - 4;
        end = totalPages - 1;
    }

    for (let i = start; i <= end; i++) {
        if (i > 1 && i < totalPages) {
            pageNumbers.push(i);
        }
    }

    if (currentPage < totalPages - 3) {
        pageNumbers.push("right-ellipsis");
    }

    if (totalPages > 1) {
        pageNumbers.push(totalPages);
    }

    return (
        <Pagination>
            <Pagination.First
                disabled={currentPage === 1}
                onClick={() => goToPage(1)}
            />
            <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => goToPage(currentPage - 1)}
            />

            {pageNumbers.map((num) =>
                typeof num === "string" && num.includes("ellipsis") ? (
                    <Pagination.Ellipsis key={num} className="ellipsis" disabled />
                ) : (
                    <Pagination.Item
                        key={num}
                        active={num === currentPage}
                        onClick={() => goToPage(num)}
                    >
                        {num}
                    </Pagination.Item>
                )
            )}

            <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => goToPage(currentPage + 1)}
            />
            <Pagination.Last
                disabled={currentPage === totalPages}
                onClick={() => goToPage(totalPages)}
            />
        </Pagination>
    );
};

export default PaginationComponent;